import app from '@/app';

/* @ngInject */
function stateConfig($stateProvider, PAGE_SIZES, SMALL_PAGE_SIZES) {
	const states = [
		{
			name: 'pavementPerformance',
			parent: 'analysis',
			url: '/pavementPerformances?page&sort&size&road&campaign&plantype',
			component: 'pavementPerformanceSearch',
			data: {
				viewAuthorities: ['ANALYSIS_READ', 'PAVEMENTPERFORMANCE_READ'],
				editAuthorities: ['ANALYSIS_WRITE', 'ANALYSIS_PARTIAL_WRITE', 'PAVEMENTPERFORMANCE_WRITE']
			},
			params: {
				page: {
					value: 0,
					type: 'int',
					squash: true,
					dynamic: true
				},
				size: {
					value: 10,
					type: 'int',
					squash: true,
					dynamic: true
				},
				sort: {
					value: 'name,asc',
					squash: true,
					dynamic: true
				},
				road: {
					type: 'int',
					squash: true,
					dynamic: true
				},
				campaign: {
					type: 'int',
					squash: true,
					dynamic: true
				},
				plantype: {
					type: 'int',
					squash: true,
					dynamic: true
				}
			},
			resolve: {
				/* @ngInject */
				allOrganizations: [
					'Organization',
					Organization => {
						return Organization.query({ sort: 'name,asc' }).$promise;
					}
				],
				/* @ngInject */
				allRoads: Road => Road.query({ sort: 'name,asc', empty: false }).$promise,
				/* @ngInject */
				allCampaigns: Campaign =>
					Campaign.query({ sort: 'name,asc', empty: false }).$promise,
				/* @ngInject */
				allCriteriaSets: CriteriaSet => CriteriaSet.query({ sort: 'name,asc' }).$promise,

        /* @ngInject */
        allGrowthRates: GrowthRate => GrowthRate.query({query: ''}).$promise
			}
		},
		{
			name: 'pavementPerformance.detail',
			url: '/{id}',
			component: 'pavementPerformanceDetail',
			resolve: {
				/* @ngInject */
				entity: (PavementPerformance, $transition$, entityInjector) =>
					entityInjector(PavementPerformance, $transition$.params().id, {})
			}
		},
		{
			name: 'pavementPerformance.result',
			url:
				'/{id}/result?milestonePage&milestoneSize&yearPage&yearSize&direction&lanes&metric',
			component: 'pavementPerformanceResult',
			params: {
				milestonePage: {
					value: 0,
					type: 'int',
					squash: true,
					dynamic: true
				},
				milestoneSize: {
					value: PAGE_SIZES[3],
					type: 'int',
					squash: true,
					dynamic: true
				},
				yearSize: {
					value: SMALL_PAGE_SIZES[1],
					type: 'int',
					squash: true,
					dynamic: true
				},
				yearPage: {
					value: 0,
					type: 'int',
					squash: true,
					dynamic: true
				},
				direction: {
					value: null,
					squash: true,
					dynamic: true
				},
				lanes: {
					array: true,
					value: [],
					type: 'int',
					squash: true,
					dynamic: true
				},
				metric: {
					value: null,
					squash: true,
					dynamic: true
				}
			},
			resolve: {
				/* @ngInject */
				allMetrics: Metadata =>
					Metadata.getMetrics({ measurement: 'KPI', view: 'PAVEMENTPERFORMANCE' }),
				/* @ngInject */
				entity: (PavementPerformance, $transition$, entityInjector) =>
					entityInjector(PavementPerformance, $transition$.params().id, {})
			}
		},
		{
			name: 'pavementPerformance.chartLine',
			url:
				'/{id}/resultChartLine?milestonePage&milestoneSize&yearPage&yearSize&direction&lanes&metric&chartYear&beforeBuilt&years',
			component: 'pavementPerformanceResultChartLine',
        params: {
          milestonePage: {
            value: 0,
            type: 'int',
            squash: true,
            dynamic: true
          },
          milestoneSize: {
            value: PAGE_SIZES[3],
            type: 'int',
            squash: true,
            dynamic: true
          },
          yearSize: {
            value: SMALL_PAGE_SIZES[1],
            type: 'int',
            squash: true,
            dynamic: true
          },
          yearPage: {
            value: 0,
            type: 'int',
            squash: true,
            dynamic: true
          },
          direction: {
            value: null,
            squash: true,
            dynamic: true
          },
          lanes: {
            array: true,
            value: [],
            type: 'int',
            squash: true,
            dynamic: true
          },
          metric: {
            value: null,
            squash: true,
            dynamic: true
          },
          beforeBuilt: {
            value: 0,
            type: 'int',
            squash: true,
            dynamic: true
          },
          milestones: {
            value: [],
            squash: true,
            dynamic: true
          },
          headYear: {
            value: null,
            type: 'int',
            squash: true,
            dynamic: true
          },
          tailYear: {
            value: null,
            type: 'int',
            squash: true,
            dynamic: true
          }
        },
        resolve: {
          /* @ngInject */
          allMetrics: Metadata =>
            Metadata.getMetrics({ measurement: 'KPI', view: 'ANALYSIS' }),
          /* @ngInject */
          entity: (Plan, $transition$, entityInjector) =>
            entityInjector(Plan, $transition$.params().id, {})
        }
      },
		{
			name: 'pavementPerformance.overview',
			url: '/{pavementPerformanceId}/overviews/{overviewId}',
			component: 'pavementPerformanceOverviewWrapper'
		}
	];

	states.forEach(state => $stateProvider.state(state));
}

app.config(stateConfig);
